import { Model } from 'miragejs';

/**
 * This is a Mirage model that doesn't have a corresponding ember-data model.
 * Mirage models are schemaless so we don't need to define the attributes on this.
 * What we _expect_ to exist on here are:
 * `id` - the role ID
 * `name` - the role name
 * `roleScope` - one of 'company', 'location', or 'zone', depending on the scope of the role
 * `type` - one of 'default' or 'custom'
 * `permissions` - array of string permissions
 */
export default Model.extend();
